/** Anatomy ("Acts API") integration hooks — the desk pages and the admin settings page. */
import { useCCMS } from '../useCCMS';
export function useAnatomyServices() {
    const { services } = useCCMS();
    if (!services?.anatomy) {
        throw new Error('Anatomy services not available. Ensure CCMSProvider is configured with anatomy services.');
    }
    return services.anatomy;
}
/** People, follow-ups, meetings, activity. */
export function useAnatomyService() {
    return useAnatomyServices().anatomy;
}
/** Settings + connection test (admin). */
export function useAnatomySettingsService() {
    return useAnatomyServices().settings;
}
//# sourceMappingURL=useAnatomyServices.js.map